import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { HomeHeader } from '../home/HomeHeader'
import { LanguagePreferences } from './LanguagePreferences'

export function Settings() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await logout()
      navigate('/')
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return (
    <div className="settings-page min-h-screen bg-background">
      <HomeHeader user={user} onLogout={handleLogout} />
      
      <div className="container mx-auto px-4 py-6">
        {/* Compact Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="w-2 h-8 bg-primary rounded-full"></div>
          <div>
            <h1 className="text-2xl font-bold text-foreground">Settings</h1>
            <p className="text-sm text-muted-foreground">
              Manage your account configuration and preferences
            </p>
          </div>
        </div>

        {/* Settings Content */}
        <LanguagePreferences />
      </div>
    </div>
  )
}
